// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Button } from 'components/Buttons';
import Typography from 'components/Typography/Typography';
import { palette, pxToEm, theme } from 'theme';

export const Tooltip = styled.div<{ align?: 'left' | 'right' }>`
  color: ${palette.common.white};
  position: absolute;
  border-radius: ${pxToEm(15)};
  background-color: ${palette.grey[800]};
  font-size: ${pxToEm(12)};
  line-height: ${pxToEm(20)};
  padding: ${pxToEm(7)} ${pxToEm(10)};
  display: none;
  white-space: nowrap;
  top: 100%;
  ${({ align = 'left' }) => (align === 'left' ? 'left: 0;' : 'right: 0;')};

  ${theme.breakpoints.down('md')} {
    display: none !important;
  }
`;

export const Container = styled.div`
  ${theme.breakpoints.down('md')} {
    padding: ${pxToEm(16)} 0 0;
  }
`;

export const Group = styled.div`
  margin-bottom: ${pxToEm(32)};
`;

export const Title = styled(Typography)`
  padding: ${pxToEm(16)} 0;

  ${theme.breakpoints.down('md')} {
    padding: ${pxToEm(4)} 0;
    font-size: ${pxToEm(18)};
    line-height: ${pxToEm(24)};
  }
`;

export const ListViewItems = styled.div`
  margin-bottom: ${pxToEm(16)};
`;

export const Tag = styled.div`
  padding: ${pxToEm(4)} ${pxToEm(12)};
  border-radius: ${pxToEm(50)};
  background-color: ${palette.secondary.main};
  transition: background-color 0.3s;
  max-width: 25%;
  position: relative;

  &:hover {
    ${Tooltip} {
      display: block;
    }
  }
`;

export const Item = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${pxToEm(16)} 0;
  border-bottom: 1px solid ${palette.grey[50]};
  position: relative;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    background: ${palette.grey[50]};
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    &:before {
      opacity: 1;
    }

    ${Tag} {
      background-color: ${palette.common.white};
    }
  }

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;

    &:before {
      display: none;
    }
  }
`;

export const ItemData = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: ${pxToEm(20)};

  ${theme.breakpoints.down('md')} {
    margin-right: 0;
    width: 100%;
  }
`;

export const ItemCover = styled.div`
  width: ${pxToEm(120)};
  height: ${pxToEm(71)};
  border-radius: ${pxToEm(8)};
  overflow: hidden;
  margin-right: ${pxToEm(20)};
  background: ${palette.secondary.main};

  ${theme.breakpoints.down('md')} {
    margin-right: ${pxToEm(12)};
    flex: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - ${pxToEm(132)});
  }
`;

export const ItemTitleWrapper = styled.div`
  width: ${pxToEm(380)};
  margin-right: auto;

  ${theme.breakpoints.down('md')} {
    width: 100%;
    margin-right: 0;
  }
`;

export const ItemTitle = styled(Typography)`
  font-size: ${pxToEm(20)};
  line-height: ${pxToEm(32)};
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${theme.breakpoints.down('md')} {
    font-size: ${pxToEm(16)};
    line-height: ${pxToEm(24)};
  }
`;

export const ItemInfoWrapper = styled.div`
  margin: 0 auto 0 0;
  width: ${pxToEm(160)};

  ${theme.breakpoints.down('md')} {
    margin: 0;
    width: 100%;
  }
`;

export const ItemInfo = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Tags = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: ${pxToEm(8)};
  width: ${pxToEm(320)};
  justify-content: flex-end;

  ${theme.breakpoints.down('md')} {
    margin-left: 0;
    margin-top: ${pxToEm(12)};
    justify-self: flex-start;
    justify-content: flex-start;
    width: 100%;
  }
`;

export const TagText = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Link = styled(Button)``;

export const GroupBottom = styled.div`
  display: flex;
  justify-content: center;
`;
